<template>
  <div class="container">

    <heading-one class="-margin-md">お探しのページが見つかりませんでした</heading-one>

    <section>
      <p>お探しのページが移動または削除されたか、URLの入力間違いの可能性があります。<br>
        au PAY スマートローントップより目的のページをお探しください。<br>
        ３秒後にau PAY スマートローントップへ自動的に遷移します。</p>
    </section>

    <btngroup-single class="-margin-lg">
      <btn-main class="-main -md" routerName="sv001">
        au PAY スマートローントップへ
      </btn-main>
    </btngroup-single>

  </div>
</template>

<script>
import HeadingOne from '../components/heading/HeadingOne'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'

export default {
  name: 'Tem-028',
  metaInfo: {
    title: 'お探しのページが見つかりませんでした',
    meta: [
      {name: 'description', content: ''},
      {name: 'keywords', content: ''}
    ]
  },
  components: {
    BtnMain,
    BtngroupSingle,
    HeadingOne
  },
  data () {
    return {
    }
  },
  methods: {
    goToServiceTop () {
      this.$router.push({name: 'sv001'})
    }
  },
  mounted () {
    setTimeout(this.goToServiceTop, 3000)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Tem028.vue